import type { ReactNode } from 'react';

export interface StatGroupProps {
    /** One or more `Stat` elements. A single figure is a group with one `Stat`. */
    children: ReactNode;
}

export interface StatProps {
    /** What the figure is; rendered above the value and announced with it. */
    label: ReactNode;
    /** The figure, already formatted by the caller (for example with the shared money formatter). */
    value: ReactNode;
}

const GROUP_CLASSES =
    'grid grid-cols-1 divide-y divide-mp-border rounded-lg bg-mp-surface sm:grid-flow-col sm:auto-cols-fr sm:divide-x sm:divide-y-0';
const ITEM_CLASSES = 'flex min-w-0 flex-col gap-1 px-6 py-4';
const LABEL_CLASSES = 'text-sm text-mp-muted';
const VALUE_CLASSES = 'text-2xl font-semibold text-mp-foreground';

export function StatGroup({ children }: StatGroupProps) {
    return <dl className={GROUP_CLASSES}>{children}</dl>;
}

export function Stat({ label, value }: StatProps) {
    return (
        <div className={ITEM_CLASSES}>
            <dt className={LABEL_CLASSES}>{label}</dt>
            <dd className={VALUE_CLASSES}>{value}</dd>
        </div>
    );
}
